// HTTP REQUEST METHODS //
export const GET = "GET";
export const POST = "POST";
export const PUT = "PUT";
export const DELETE = "DELETE";

// HTTP RESPONSE CODES //
export const NOT_FOUND = 404;
export const FORBIDDEN = 403;
export const UNAUTHORIZED = 401;
export const BAD_REQUEST = 400;
export const INTERNAL_SERVER_ERROR = 500;
export const REQUEST_TIMED_OUT = 504;
export const CREATED = 201;